<div class="validateMe">
  <input type="text"
         [value]="getModelString()"
         (focusout)="onChange($event);"
         [formControlName]="formInputName"
         [class]="'form-control ' + (touched && (error || formatError) ? 'border border-danger text-danger' : '') ">
  <div *ngIf="touched && (error || formatError)" class="alert alert-danger">{{formatError | translate}}</div>
</div>
